export default __webpack_public_path__ + "static/media/BOD Regular Meeting 02 September 2021.92582a70.pdf";